"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function WayPoint({
  isArrival,
  bikeStationsMap,
  route: {
    wayPoints,
    sections
  },
  sectionIndex
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const section = sections[sectionIndex];
  const departure = wayPoints[sectionIndex];
  const arrival = wayPoints[wayPoints.length - 1];
  const prevSection = sections[sectionIndex - 1];
  const bikeStations = 'bikeStations' in section && section.bikeStations || undefined;
  const departureBikeStation = bikeStations ? bikeStations.from : prevSection && 'bikeStations' in prevSection && prevSection.bikeStations?.to || undefined;
  return /*#__PURE__*/_react.default.createElement(_Box2.default, null, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontSize: "0.875rem",
    fontWeight: 700
  }, isArrival ? arrival.addressDetail?.primaryText : departureBikeStation ? t('commons.routing.roadmap.bike_station_name', {
    name: bikeStationsMap[departureBikeStation.bikeStationId]?.name || ''
  }) : departure.addressDetail?.primaryText), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "#00000099",
    fontSize: "0.875rem",
    fontWeight: 400
  }, isArrival ? arrival.addressDetail?.secondaryText : departureBikeStation ? departure.address : departure.addressDetail?.secondaryText));
}
var _default = exports.default = WayPoint;